module.exports = __webpack_public_path__ + "static/media/Joshua Streeter Headshot_1688993045395.1ab82236.jpeg";